/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 8L14.625 8.375L12 11L9.375 8.375L9 8M6.5 10.5L12 16L17.5 10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M15 8L14.625 8.375L12 11L9.375 8.375L9 8M6.5 10.5L12 16L17.5 10.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.53033 7.46967C9.23744 7.17678 8.76256 7.17678 8.46967 7.46967C8.17678 7.76256 8.17678 8.23744 8.46967 8.53033L8.84467 8.90533L11.4697 11.5303C11.7626 11.8232 12.2374 11.8232 12.5303 11.5303L15.1553 8.90533L15.5303 8.53033C15.8232 8.23744 15.8232 7.76256 15.5303 7.46967C15.2374 7.17678 14.7626 7.17678 14.4697 7.46967L14.0947 7.84467L12 9.93934L9.90533 7.84467L9.53033 7.46967ZM7.03033 9.96967C6.73744 9.67678 6.26256 9.67678 5.96967 9.96967C5.67678 10.2626 5.67678 10.7374 5.96967 11.0303L11.4697 16.5303C11.7626 16.8232 12.2374 16.8232 12.5303 16.5303L18.0303 11.0303C18.3232 10.7374 18.3232 10.2626 18.0303 9.96967C17.7374 9.67678 17.2626 9.67678 16.9697 9.96967L12 14.9393L7.03033 9.96967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M15 8L14.625 8.375L12 11L9.375 8.375L9 8M6.5 10.5L12 16L17.5 10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 8L14.625 8.375L12 11L9.375 8.375L9 8M6.5 10.5L12 16L17.5 10.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.46967 7.46967C8.76256 7.17678 9.23744 7.17678 9.53033 7.46967L9.90533 7.84467L12 9.93934L14.0947 7.84467L14.4697 7.46967C14.7626 7.17678 15.2374 7.17678 15.5303 7.46967C15.8232 7.76256 15.8232 8.23744 15.5303 8.53033L15.1553 8.90533L12.5303 11.5303C12.2374 11.8232 11.7626 11.8232 11.4697 11.5303L8.84467 8.90533L8.46967 8.53033C8.17678 8.23744 8.17678 7.76256 8.46967 7.46967ZM5.96967 9.96967C6.26256 9.67678 6.73744 9.67678 7.03033 9.96967L12 14.9393L16.9697 9.96967C17.2626 9.67678 17.7374 9.67678 18.0303 9.96967C18.3232 10.2626 18.3232 10.7374 18.0303 11.0303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.96967 11.0303C5.67678 10.7374 5.67678 10.2626 5.96967 9.96967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
